const toggleDisplayAndActive = (idToShow, idToHide1, idToHide2) => {
    document.querySelector(`slideshow-component#${idToShow}`).style.display = 'block';
    document.querySelector(`a#${idToShow}-button`).classList.add('active');

    document.querySelector(`slideshow-component#${idToHide1}`).style.display = 'none';
    document.querySelector(`a#${idToHide1}-button`).classList.remove('active');

    document.querySelector(`slideshow-component#${idToHide2}`).style.display = 'none';
    document.querySelector(`a#${idToHide2}-button`).classList.remove('active');
}

document.querySelector('#collection-button').addEventListener('click', () => {
    toggleDisplayAndActive('collection', 'collection-2', 'collection-3');
});

document.querySelector('#collection-2-button').addEventListener('click', () => {
    toggleDisplayAndActive('collection-2', 'collection', 'collection-3');
});

document.querySelector('#collection-3-button').addEventListener('click', () => {
    toggleDisplayAndActive('collection-3', 'collection', 'collection-2');
});